import { createAction } from '@reduxjs/toolkit'

/**
 * Команда «Выйти». Исполняет listener composition (`listeners.ts`): стирает
 * записи пользователя, сбрасывает кэш и токен антифоргери и уводит на выход
 * Gateway, который гасит И cookie, И SSO-сессию (D-086).
 */
export const signOutRequested = createAction('shell/signOutRequested')

/**
 * Команда «Войти»: полная навигация на вход Gateway (OIDC Code + PKCE у BFF) с
 * возвратом на адрес, где человек был. Своего входа у клиента нет (ADR-16).
 */
export const signInRequested = createAction<{ returnUrl: string }>('shell/signInRequested')

/** Соседняя вкладка браузера сообщила о выходе этого пользователя. */
export const signedOutElsewhere = createAction<{ userId: string }>('shell/signedOutElsewhere')
